import { Component } from '@angular/core';

@Component({
  selector: 'app-orders-idea',
  standalone: true,
  imports: [],
  templateUrl: './orders-idea.component.html',
  styleUrl: './orders-idea.component.sass'
})
export class OrdersIdeaComponent {

}
